import { render, staticRenderFns } from "./tabsTable.vue?vue&type=template&id=5604b3ac&"
import script from "./tabsTable.vue?vue&type=script&lang=js&"
export * from "./tabsTable.vue?vue&type=script&lang=js&"
import style0 from "./tabsTable.vue?vue&type=style&index=0&id=5604b3ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports